import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import * as apiClient from "../../api";
import { useClinicianContext } from "../ClinicianContext";

interface AddPatientDialogProps {
  open: boolean;
  onClose: () => void;
}

const AddPatientDialog: FC<AddPatientDialogProps> = ({ open, onClose }) => {
  const [accessCode, setAccessCode] = useState("123456");
  const [clinician] = useClinicianContext();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadAccessCode = async () => {
      const res = await apiClient.generateAccessCode(clinician.clinicianId);
      const { code } = res.data;
      setAccessCode(code);
      setLoaded(true);
    };

    if (open) {
      loadAccessCode();
    } else {
      setLoaded(false);
    }
  }, [clinician, open]);

  const displayAccessCode = `${accessCode.slice(0, 3)} ${accessCode.slice(3)}`;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add new patient</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            Please ask your patient to grant you access to their data using the
            following code. Note that the code expires in 5 minutes.
          </Typography>
          <Typography textAlign="center" variant="h1" component="p">
            {loaded ? displayAccessCode : <CircularProgress />}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPatientDialog;
